import axios from "axios";

// Get base URL strictly from .env
const getApiUrl = () => {
  return process.env.REACT_APP_API_URL || "http://localhost:4000/api";
};

// Create an axios instance specifically for Reels
const reelsApi = axios.create({
  baseURL: getApiUrl(),
});

/**
 * Fetch Instagram Reels from backend
 */
export const getInstagramReels = async () => {
  try {
    // const response = await reelsApi.get('/instagram/reels');
    const response = await reelsApi.get("/instagram/reels/test");
    return response.data; // Axios automatically parses the JSON
  } catch (error) {
    console.error("API Call Error in getInstagramReels:", error);
    throw error;
  }
};
